import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TcV2LoyaltyProgramsListItemMobileComponent } from '@features/transfer-connect-v2/components/loyalty-programs-list-item-mobile/loyalty-programs-list-item-mobile.component';

@Component({
  selector: 'rd-anz-tcv2-loyalty-programs-list-item-mobile',
  templateUrl: './loyalty-programs-list-item-mobile.component.html',
  styleUrls: ['./loyalty-programs-list-item-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzTcV2LoyaltyProgramsListItemMobileComponent extends TcV2LoyaltyProgramsListItemMobileComponent {
  @HostBinding('class.rd-anz-tcv2-loyalty-programs-list-item-mobile')
  componentClass = true;
}
